export default "__VITE_ASSET__CgvNiLdh__"